module.exports = __webpack_public_path__ + "img/zanorari05.c12f85cd.jpg";